function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M287.16,248c5.184-11.256,8.232-23.664,8.68-36.744c20.704-21.864,32.16-50.28,32.16-80.512V96 c0-20.256-15.144-37.056-34.704-39.648C276.512,21.96,241.632,0,203.072,0h-13.464c-26.016,0-51.664,8.8-72.208,24.776 C88.544,47.216,72,81.056,72,117.608v13.136c0,30.232,11.456,58.648,32.168,80.512c1.04,30.68,16.488,57.712,39.832,74.56v19.768 L81.44,319.48C33.488,330.144,0,371.88,0,421.008V496h272h8h216V248H287.16z M104,152v33.304c-10.376-16.144-16-34.912-16-54.56 v-13.136c0-31.584,14.296-60.824,39.224-80.208C144.976,23.6,167.136,16,189.608,16h13.464c33.808,0,64.256,20.08,77.576,51.152 l2.08,4.848H288c13.232,0,24,10.768,24,24v34.744c0,19.648-5.624,38.416-16,54.56V120h-17.536l-2.76,1.104 C224.456,141.6,170.48,152,115.264,152H104z M80,448v32H16v-58.992c0-41.56,28.336-76.888,68.904-85.896L104,330.864V448h-8h-8 H80z M272,480H96v-16h24V327.304l24-5.336V464h112V321.968l16,3.56V480z M200,376c15.664,0,29.824-6.48,40-16.888V448h-80 v-88.888C170.176,369.52,184.336,376,200,376z M160,320v-1.584V312v-16.84c12.192,5.616,25.712,8.84,40,8.84 c14.288,0,27.808-3.224,40-8.84V312v6.416V320c0,22.056-17.944,40-40,40C177.944,360,160,342.056,160,320z M272,309.136 l-16-3.552v-19.768c5.872-4.232,11.232-9.104,16-14.528V309.136z M280,208c0,44.112-35.888,80-80,80s-80-35.888-80-80v-40.024 c55.016-0.568,108.816-11.12,160-31.368V208z M368,264h32v64h-32V264z M480,480H288V264h64v80h64v-80h64V480z"
}), React.createElement("rect", {
  x: 448,
  y: 448,
  width: 16,
  height: 16
}), React.createElement("rect", {
  x: 384,
  y: 448,
  width: 48,
  height: 16
}), React.createElement("rect", {
  x: 384,
  y: 416,
  width: 80,
  height: 16
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgCourierServices = function SvgCourierServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCourierServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/courier-services.9bef1b5b.svg";
export { ForwardRef as ReactComponent };